// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6XySk","icon":"styles_icon__2nW85"};